
<div class="mat-container">
  <div mat-dialog-title>   </div>
  <div mat-dialog-content style="text-align: center;">
  
    <form class="example-form">
      <mat-form-field class="example-full-width" appearance="fill">
        <mat-label>Edit Name</mat-label>
        <input matInput [placeholder]="data.alternateName != '' && data.alternateName != null ? data.alternateName : data.assetTypeName" [(ngModel)]="alternateName" name="nameInput" #inputElement>
      </mat-form-field>
    </form>
  </div>
  
  <div mat-dialog-actions class="buttons">
    
    <button mat-flat-button mat-dialog-close (click)="close(false)">Close</button>
    <button type="button" mat-flat-button mat-dialog-close  color="primary" (click)="close(true)"> Save</button>
      
  </div>     
  
</div>